<template>
    <uw-content title="票据类型" padding="10px">
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.dialogCreate.Open()">新的票据类型</el-button>
        </template>
        <uw-table :show-header="false" :show-footer="false">
            <template slot="data">
                <vxe-table ref="xTable" :data="table" height="100%">
                    <vxe-column width="60" type="seq" title="ID"></vxe-column>
                    <vxe-column min-width="160" field="name" title="票据类型"></vxe-column>
                    <vxe-column width="120" field="taxation_rate" title="税率">
                        <template #default="{ row }">
                            {{ row.taxation_rate }}%
                        </template>
                    </vxe-column>
                    <vxe-column width="120" field="state" title="状态">
                        <template #default="{ row }">
                            <el-link :underline="false" v-if="row.state" type="success">已启用</el-link>
                            <el-link :underline="false" v-if="!row.state" type="info">未启用</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="120" field="created_user.name" title="创建人" sortable></vxe-column>
                    <vxe-column width="120" field="created_user.name" title="更新人" sortable></vxe-column>
                    <vxe-column width="140" field="created_at" title="创建日期" sortable></vxe-column>
                    <vxe-column width="140" field="updated_at" title="最后更新日期" sortable></vxe-column>
                    <vxe-column width="130" title="管理" fixed="right">
                        <template #default="{ row }">
                            <el-link type="primary" icon="el-icon-edit-outline" class="w-margin-r-10" @click="$refs.dialogUpdate.Open(row.id)">修改</el-link>
                            <el-link type="danger" icon="el-icon-delete" @click="TableDelete(row.id)">移除</el-link>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>
        </uw-table>
        <config-invoice-type-create ref="dialogCreate" @onChange="TableSearch" />
        <config-invoice-type-update ref="dialogUpdate" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            table: [],
        }
    },
    mounted() {
        this.TableSearch()
    },
    methods: {
        TableSearch() {
            this.$http.post('/9api/config-invoice-type/search-all', { append: ['created_user', 'updated_user' ] }).then(rps => {
                this.table = rps.data
            })
        },
        TableDelete(id) {
            this.$http.post('/9api/config-invoice-type/delete', { id: id }).then(rps => {
                this.TableSearch()
            })
        },
    }
}
</script>